<app-login-base pageHeader="Sign In">
  <ng-container *ngIf="!showOtpVerification">
    <form #signInForm="ngForm" (ngSubmit)="SignIn(signInForm)">
      <div class="d-flex align-items-center justify-content-center">
        <div class="col-12 text-center">
          <div class="md-form input-white">
            <div class="input-group">
              <div class="input-container">
                <input
                  type="email"
                  id="authEmail"
                  class="form-control auto-bottom-margin"
                  mdbInput
                  mdbValidate
                  [(ngModel)]="signIn.email"
                  name="email"
                  #email="ngModel"
                  required
                  [pattern]="emailRegExpression"
                />
                <label for="authEmail">E-mail</label>
                <mdb-error
                  class="p-1"
                  *ngIf="email.invalid && (email.dirty || email.touched)"
                  >Please ensure email address is valid</mdb-error
                >
              </div>
            </div>
          </div>

          <div class="md-form input-white">
            <div class="input-group">
              <div class="input-container">
                <input
                  [type]="showPasswordField ? 'password' : 'text'"
                  id="authPassword"
                  class="form-control auto-bottom-margin"
                  mdbInput
                  mdbValidate
                  [(ngModel)]="signIn.password"
                  name="password"
                  #password="ngModel"
                  required
                />
                <label for="authPassword">Password</label>
                <mdb-error
                  class="p-1 validation-message"
                  *ngIf="password.invalid && password.touched"
                >
                  Please enter a password
                </mdb-error>
              </div>
              <div class="input-group-append">
                <mdb-icon
                  *ngIf="!showPasswordField"
                  far
                  icon="eye"
                  class="prefix small-eye"
                  (click)="showPassword()"
                  size="lg"
                ></mdb-icon>
                <mdb-icon
                  *ngIf="showPasswordField"
                  far
                  icon="eye-slash"
                  class="prefix small-eye"
                  (click)="showPassword()"
                  size="lg"
                ></mdb-icon>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-around">
            <div class="col-sm-10 col-md-8">
              <button
                *ngIf="!busy"
                mdbBtn
                color="dooya"
                block="true"
                class="my-4"
                type="submit"
              >
                Sign in
              </button>
              <app-loading [busy]="busy"></app-loading>
            </div>
          </div>

          <div class="d-flex justify-content-around my-2">
            <a [routerLink]="['resetpassword']" [queryParams]="{ returnUrl: userToken.redirectUrl }" routerLinkActive="active"
              >Forgot password?</a
            >
          </div>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-container *ngIf="showOtpVerification">
    <form #otpForm="ngForm" (ngSubmit)="VerifyOtp(otpForm)">
      <div class="d-flex align-items-center justify-content-center">
        <div class="col-12 text-center">
          <p class="h5 mb-4">Please verify your identity</p>
          <div class="otp-info-panel mb-4">
            <p class="mb-0">
              An OTP has been sent to
              <span>{{ signIn.email }}</span>
            </p>
          </div>

          <div class="md-form input-white">
            <div class="input-group mb-3">
              <input
                type="text"
                id="otp"
                class="form-control auto-bottom-margin"
                mdbInput
                mdbValidate
                name="otp"
                #otp="ngModel"
                [(ngModel)]="userToken.otp"
                required
              />
              <label for="txtOtp">OTP</label>
              <mdb-error class="p-1" *ngIf="otp.invalid"
                >OTP is required</mdb-error
              >
            </div>
          </div>

          <div class="d-flex justify-content-around">
            <div class="col-sm-10 col-md-8">
              <button
                *ngIf="!otpBusy"
                mdbBtn
                color="dooya"
                block="true"
                class="my-4"
                type="submit"
              >
                Verify OTP
              </button>
              <app-loading [busy]="otpBusy"></app-loading>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
  <div *ngIf="showError" class="alert alert-danger" role="alert">
    {{ errorMsg }}
  </div>
</app-login-base>
